"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activityDelete = activityDelete;
exports.activityDetail = activityDetail;
exports.activityList = activityList;
exports.activitySave = activitySave;
exports.activitySelect = activitySelect;
var _request = _interopRequireDefault(require("@/utils/request"));
// 超级补贴活动列表
function activityList(params) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/list',
    method: 'get',
    params: params
  });
}
// 超级补贴活动下拉选项（商品页所属活动筛选用）
function activitySelect(params) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/select',
    method: 'get',
    params: params
  });
}
// 超级补贴活动详情
function activityDetail(params) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/detail',
    method: 'get',
    params: params
  });
}
// 超级补贴活动保存（有 id 为编辑，无 id 为新建）
function activitySave(data) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/save',
    method: 'post',
    data: data
  });
}
// 超级补贴活动删除（进行中不可删）
function activityDelete(data) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/del',
    method: 'post',
    data: data
  });
}